import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import SinglePageApp from "./components/SinglePageApp";
import Sep17Talk from "./components/Sep17Talk";
import ProjectLandingPage from "./components/ProjectLandingPage";
import BlogLandingPage from "./components/BlogLandingPage";
import Music from "./components/Music";
import PublicSpeaking from "./components/PublicSpeaking";
import Dance from "./components/Dance";
import Singing from "./components/Singing";
import ProjectBetterTogether from "./components/ProjectSmart/ProjectSmartV4-better-together";
import ProjectHow2Learn from "./components/ProjectSmart/ProjectSmartV4-how2learn";
import ProjectSmartV1 from "./components/ProjectSmart/ProjectSmartV1";
import ProjectSmartV2 from "./components/ProjectSmart/ProjectSmartV2";
import ProjectSmartV3 from "./components/ProjectSmart/ProjectSmartV3";
import ProjectSmartV4 from "./components/ProjectSmart/ProjectSmartV4";
import ProjectSmartV5 from "./components/ProjectSmart/ProjectSmartV5";
import ProjectSmartV6 from "./components/ProjectSmart/ProjectSmartV6";
import ProjectRelief from "./components/ProjectRelief/ProjectRelief";
import ProjectReliefWebcamTest from "./components/ProjectRelief/WebcamTest";
import ProjectReliefLearningVideo from "./components/ProjectRelief/LearningVideo";
import ProjectReliefLearningTasks from "./components/ProjectRelief/LearningTasks";
import ProjectReliefDebrief from "./components/ProjectRelief/Debrief";
import ResponsiveAppBar from "./components/ResponsiveProfileBar";
import Footer from "./components/Footer";
import SinglePost from "./components/SinglePost";
import Icebreaking from "./components/ProjectSocialIntelligence/Icebreaking";
import EvalV1 from "./components/ProjectPersonalLlmEval/EvalV1";
import EvalV2 from "./components/ProjectPersonalLlmEval/EvalV2";
import Test from "./components/Test";
import InteractionDimensions3DV1 from "./components/ProjectSocialIntelligence/InteractionDimensions3DV1";
import InteractionDimensions3DV2 from "./components/ProjectSocialIntelligence/InteractionDimensions3DV2";
import InteractionDimensions3DV3 from "./components/ProjectSocialIntelligence/InteractionDimensions3DV3";
import Demo from "./components/Demo";
import JournalingPipeline from "./components/JournalingPipeline";
import AcademicWordGame from "./components/ProjectSmart/AcademicWordGame";
import PrivacyPolicy from "./components/Legal/PrivacyPolicy";
import TermsOfService from "./components/Legal/TermsOfService";
import PerspectiveDebate from "./components/ProjectPerspectiveDebate/PerspectiveDebate";
import ProjectSelfHelp from "./components/ProjectSmart/ProjectSelfHelp";
import VAL3DDiagram from "./components/ProjectVALModel/VAL3DDiagram";
import PasswordPrompt from "./components/PasswordPrompt";
import EmotionAnalysis from "./components/EmotionAnalysis";
import AdvisorBoard from "./components/AdvisorBoard";
import Acmmi from "./components/CourseACMMI/Acmmi";
import ProjectDecisionMaking from "./components/ProjectDecisionMaking";
import XProjectsGrid from "./components/Inspired/XProjectsGrid";
import ImageAgent from "./components/ProjectNeuromantics/ImageAgent/ImageAgent";
import EngageAgent from "./components/EngageAgent";

import { BrowserRouter, Route, Routes } from "react-router-dom";
import AppContainer from "./components/AppContainer"; // Import the AppContainer

// Code-split: this essay carries ~300KB of prose, claims and a 254-entry
// bibliography. Loading it eagerly would put that in the bundle every other
// page pays for, so it is fetched only when the route is visited.
const LivingInternet = React.lazy(() =>
  import("./components/BlogLivingInternet/LivingInternet")
);

// Client page for 王祖贤. Its own chunk: the page pulls in three.js for the
// hero, which no other route pays for.
const JoeyWongPage = React.lazy(() =>
  import("./components/ClientJoeyWong/JoeyWongPage")
);
const JoeyWongCheckout = React.lazy(() =>
  import("./components/ClientJoeyWong/JoeyWongCheckout")
);

function ElementConstructorWrapper({
  Component,
  showStars = false,
  hideFooter = false,
  passwordProtected = false,
}) {
  const [isAuthenticated, setIsAuthenticated] = React.useState(
    !passwordProtected
  );

  if (passwordProtected && !isAuthenticated) {
    return <PasswordPrompt onSuccess={() => setIsAuthenticated(true)} />;
  }

  return !showStars ? (
    <>
      {Component}
      {!hideFooter && <Footer />}
    </>
  ) : (
    <AppContainer>
      <ResponsiveAppBar />
      {Component}
      {!hideFooter && <Footer />}
    </AppContainer>
  );
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/sep17-talk" element={<Sep17Talk />} />
        <Route
          exact
          path="/"
          element={
            <ElementConstructorWrapper
              Component={<SinglePageApp />}
              showStars={false}
            />
          }
        />
        <Route
          exact
          path="/project"
          element={
            <ElementConstructorWrapper
              Component={<ProjectLandingPage />}
              showStars={true}
            />
          }
        />
        <Route
          exact
          path="/inspo/x-projects"
          element={
            <ElementConstructorWrapper
              Component={<XProjectsGrid />}
              showStars={false}
              hideFooter={false}
            />
          }
        />
        <Route
          exact
          path="/blog"
          element={
            <ElementConstructorWrapper
              Component={<BlogLandingPage />}
              showStars={true}
            />
          }
        />
        <Route
          exact
          path="/engage-agent"
          element={
            <ElementConstructorWrapper
              Component={<EngageAgent />}
              showStars={false}
              hideFooter={true}
            />
          }
        />
        <Route
          exact
          path="/music"
          element={
            <ElementConstructorWrapper Component={<Music />} showStars={true} />
          }
        />
        <Route
          exact
          path="/speaking"
          element={
            <ElementConstructorWrapper
              Component={<PublicSpeaking />}
              showStars={true}
            />
          }
        />
        <Route
          exact
          path="/dance"
          element={
            <ElementConstructorWrapper Component={<Dance />} showStars={true} />
          }
        />
        <Route
          exact
          path="/singing"
          element={
            <ElementConstructorWrapper
              Component={<Singing />}
              showStars={true}
            />
          }
        />
        <Route
          exact
          path="/project/:projectId"
          element={
            <ElementConstructorWrapper
              Component={<SinglePost isProject={true} />}
            />
          }
        />

        {/* Long-form essay with its own layout. Declared before the generic
            :blogId route; react-router ranks the static segment higher anyway,
            but the ordering keeps the intent obvious. */}
        <Route
          exact
          path="/blog/the-living-internet"
          element={
            <ElementConstructorWrapper
              Component={
                <React.Suspense fallback={null}>
                  <LivingInternet />
                </React.Suspense>
              }
              showStars={false}
              hideFooter={true}
            />
          }
        />

        <Route
          exact
          path="/blog/:blogId"
          element={
            <ElementConstructorWrapper
              Component={<SinglePost isProject={false} />}
            />
          }
        />

        {/* %%%%%%%%%%%%%%% BELOW IS THE PROJECT PAGES %%%%%%%%%%%%%%% */}
        <Route
          exact
          path="/project/how-to-learn-anything"
          element={
            <ElementConstructorWrapper Component={<ProjectHow2Learn />} />
          }
        />
        <Route
          exact
          path="/project/self-compassion"
          element={
            <ElementConstructorWrapper Component={<ProjectBetterTogether />} />
          }
        />
        <Route
          exact
          path="/project/smart/v1"
          element={<ElementConstructorWrapper Component={<ProjectSmartV1 />} />}
        />
        <Route
          exact
          path="/project/smart/v2"
          element={<ElementConstructorWrapper Component={<ProjectSmartV2 />} />}
        />
        <Route
          exact
          path="/project/smart/v3"
          element={<ElementConstructorWrapper Component={<ProjectSmartV3 />} />}
        />
        <Route
          exact
          path="/project/smart/v4"
          element={<ElementConstructorWrapper Component={<ProjectSmartV4 />} />}
        />
        <Route
          exact
          path="/project/smart/v5"
          element={<ElementConstructorWrapper Component={<ProjectSmartV5 />} />}
        />
        <Route
          exact
          path="/project/smart/v6"
          element={<ElementConstructorWrapper Component={<ProjectSmartV6 />} />}
        />

        {/* mind mirror route  - point to ProjectSmartV6 */}
        <Route
          exact
          path="/glowingstar"
          element={<ElementConstructorWrapper Component={<ProjectSmartV6 />} />}
        />

        {/* Project Relief Routes */}
        <Route exact path="/project/relief" element={<ProjectRelief />} />
        <Route
          exact
          path="/project/relief/webcam-test"
          element={<ProjectReliefWebcamTest />}
        />
        <Route
          exact
          path="/project/relief/learning-video"
          element={<ProjectReliefLearningVideo />}
        />
        <Route
          exact
          path="/project/relief/learning-tasks"
          element={<ProjectReliefLearningTasks />}
        />
        <Route
          exact
          path="/project/relief/debrief"
          element={<ProjectReliefDebrief />}
        />

        {/* Project social intellignece */}
        <Route
          exact
          path="/project/social-intelligence/dimensions-of-interactions/v1"
          element={
            <ElementConstructorWrapper
              Component={<InteractionDimensions3DV1 />}
            />
          }
        />
        <Route
          exact
          path="/project/social-intelligence/dimensions-of-interactions/v2"
          element={
            <ElementConstructorWrapper
              Component={<InteractionDimensions3DV2 />}
            />
          }
        />
        <Route
          exact
          path="/project/social-intelligence/dimensions-of-interactions/v3"
          element={
            <ElementConstructorWrapper
              Component={<InteractionDimensions3DV3 />}
            />
          }
        />

        <Route
          exact
          path="/project/social-intelligence/icebreaking"
          element={<ElementConstructorWrapper Component={<Icebreaking />} />}
        />

        {/* MIT Personal Robots Group PoC */}
        <Route
          exact
          path="/project/prg/persona-llm-eval/v1"
          element={<ElementConstructorWrapper Component={<EvalV1 />} />}
        />
        <Route
          exact
          path="/project/prg/persona-llm-eval/v2"
          element={<ElementConstructorWrapper Component={<EvalV2 />} />}
        />

        {/* TEST ROUTES */}
        <Route
          exact
          path="/project/recording-testing"
          element={<ElementConstructorWrapper Component={<Test />} />}
        />

        <Route
          exact
          path="/demo"
          element={
            <ElementConstructorWrapper Component={<Demo />} showStars={true} />
          }
        />

        {/* Journaling Pipeline Visualization */}
        <Route
          exact
          path="/project/journaling-pipeline"
          element={
            <ElementConstructorWrapper
              Component={<JournalingPipeline />}
              hideFooter={true}
            />
          }
        />

        <Route
          exact
          path="/project/word-game"
          element={
            <ElementConstructorWrapper Component={<AcademicWordGame />} />
          }
        />

        {/* Emotion Analysis (webcam expressions) */}
        <Route
          exact
          path="/project/emotion-analysis"
          element={
            <ElementConstructorWrapper Component={<EmotionAnalysis />} />
          }
        />

        {/* Legal Routes */}
        <Route
          exact
          path="/privacy"
          element={<ElementConstructorWrapper Component={<PrivacyPolicy />} />}
        />
        <Route
          exact
          path="/terms"
          element={<ElementConstructorWrapper Component={<TermsOfService />} />}
        />

        {/* Perspective Debate Route */}
        <Route
          exact
          path="/project/perspective-debate"
          element={
            <ElementConstructorWrapper
              Component={<PerspectiveDebate />}
              hideFooter={true}
              passwordProtected={true}
            />
          }
        />

        <Route
          exact
          path="/self-help"
          element={
            <ElementConstructorWrapper Component={<ProjectSelfHelp />} />
          }
        />

        <Route
          exact
          path="/project/val-3d-diagram"
          element={
            <ElementConstructorWrapper
              Component={<VAL3DDiagram />}
              passwordProtected={true}
            />
          }
        />

        {/* AI Advisor Board */}
        <Route
          exact
          path="/project/advisor-board"
          element={
            <ElementConstructorWrapper
              Component={<AdvisorBoard />}
              hideFooter={true}
            />
          }
        />

        {/* ACM MI Route */}
        <Route
          exact
          path="/acmmi"
          element={
            <ElementConstructorWrapper
              Component={<Acmmi />}
              hideFooter={true}
            />
          }
        />

        {/* Project Decision Making Route */}
        <Route
          exact
          path="/project/decision-making"
          element={
            <ElementConstructorWrapper
              Component={<ProjectDecisionMaking />}
              hideFooter={true}
            />
          }
        />

        {/* Neuromantics Image Agent Route */}
        <Route
          exact
          path="/project/neuromantics/image-agent"
          element={
            <ElementConstructorWrapper
              Component={<ImageAgent />}
              hideFooter={true}
            />
          }
        />

        {/* %%%%%%%%%%%%%%% CLIENT PAGES %%%%%%%%%%%%%%% */}

        {/* 王祖贤 · 一对一咨询. /joeywong is kept as a short alias for the
            canonical /client/joeywong. */}
        {["/client/joeywong", "/joeywong"].map((path) => (
          <Route
            key={path}
            exact
            path={path}
            element={
              <ElementConstructorWrapper
                Component={
                  <React.Suspense fallback={null}>
                    <JoeyWongPage />
                  </React.Suspense>
                }
                showStars={false}
                hideFooter={true}
              />
            }
          />
        ))}

        {["/client/joeywong/checkout", "/joeywong/checkout"].map((path) => (
          <Route
            key={path}
            exact
            path={path}
            element={
              <ElementConstructorWrapper
                Component={
                  <React.Suspense fallback={null}>
                    <JoeyWongCheckout />
                  </React.Suspense>
                }
                showStars={false}
                hideFooter={true}
              />
            }
          />
        ))}
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
